import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Renderer2,
  ViewChild,
  Output,
} from '@angular/core';

import { PgRadioAnimations } from './pg-radio-animations';

let uid = 0;
@Component({
  selector: 'pg-radio-button, grit-radio-button',
  templateUrl: './pg-radio-button.component.html',
  styleUrls: ['./pg-radio-button.component.scss'],
  animations: [PgRadioAnimations.transitionSelection],
})
export class PgRadioButtonComponent {
  @HostBinding('class.pg-radio-button')
  readonly classPgRadioButton = true;
  @HostBinding('class.selected')
  get _classSelected() {
    return this.selected;
  }
  @ViewChild('radioCircleElement', { static: true })
  radioCircleElement: ElementRef;
  @Input('radioColor') radioColor: any;
  @Input()
  selected = false;

  @HostListener('mousedown', ['$event']) mouseDown(event) {
    this.renderer.addClass(this.radioCircleElement.nativeElement, 'clicked');
  }

  @HostBinding('class.is-focused')
  focused = false;
  @HostBinding('class.disabled')
  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(value: boolean) {
    this._disabled = value;
  }
  protected _disabled = false;
  @Input()
  id;
  @Input() fontWeight: number;
  @Input() fontFamily: string;
  private _setValue;
  @Input()
  set value(val: any) {
    this._setValue = val;
  }
  get value() {
    if (this._setValue === undefined || this._setValue === null) {
      return (
        this._el.nativeElement.value ||
        this._el.nativeElement.textContent.trim()
      );
    }
    return this._setValue;
  }
  @Output() click: EventEmitter<PgRadioButtonComponent> = new EventEmitter<
    PgRadioButtonComponent
  >();
  constructor(private _el: ElementRef, private renderer: Renderer2) {}
  ngOnInit() {
    if (!this.id) {
      this.id = 'radio-' + uid++;
    }
  }
  onClick(event: Event) {
    this.click.emit(this);
    event.stopPropagation();
  }
  public onFocus() {
    this.focused = true;
  }
  public onBlur() {
    this.renderer.removeClass(this.radioCircleElement.nativeElement, 'clicked');
    this.focused = false;
  }
  getId() {
    return this.id + '-label';
  }
  handleKeyDown(event: KeyboardEvent) {
    if (event.keyCode === 32 && !this.disabled) {
      this.click.emit(this);
    }
  }
}
